import { render } from "./CostConfig.vue?vue&type=template&id=ec8191ca&scoped=true"
import script from "./CostConfig.vue?vue&type=script&lang=js"
export * from "./CostConfig.vue?vue&type=script&lang=js"

import "./CostConfig.vue?vue&type=style&index=0&id=ec8191ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8191ca"]])

export default __exports__